import { Notification } from '@copera/notification';
import { render } from '@copera/notification/render';
import { useLocales } from 'src/locales';
import { useSelector } from 'src/redux/store';
import { NotificationContent } from './types';
import { navigateToByType } from './utils';

export const useNotificationContent = () => {
  const { translate } = useLocales();
  const usersList = useSelector((state) => state.workspace.usersById);

  const getNotificationContent = (
    notification: Notification,
  ): NotificationContent => {
    const sender =
      typeof notification.sender === 'object'
        ? notification.sender
        : usersList[notification.sender!];

    const owner = usersList[notification.owner!] || notification?.data;

    try {
      const data = render(
        {
          notification,
          sender,
          owner,
        },
        translate,
      );

      return {
        ...data,
        navigateTo: navigateToByType(notification),
      };
    } catch (error) {
      console.error('Failed to render notification', error);
      return {
        title: notification.type,
        description: translate('notifications.errors.render_failed'),
        icon: 'tabler:info',
      };
    }
  };

  return { getNotificationContent };
};
